import React from 'react';

import { Redirect, Route } from 'react-router-dom';
import { isAdminUser, isLoggedIn, isStaffUser } from '../utils/auth';

// This is used to determine if a user is authenticated and
// if they are allowed to visit the page they navigated to.

// If they are: they proceed to the page
// If not: they are redirected to the login page.

// If they are authenticated but without the required role they will be redirectec to unauthorized page

const PrivateRoute = props => {
  const { component: Component, staffOnly, ...rest } = props;

  if (!isLoggedIn()) {
    return <Route {...rest} render={props => <Redirect to={{ pathname: '/', state: { from: props.location } }} />} />;
  }

  if (staffOnly && !isStaffUser() && !isAdminUser()) {
    return <Route {...rest} render={() => <Redirect to={{ pathname: '/unauthorized' }} />} />;
  }

  return <Route {...rest} render={props => <Component {...props} />} />;
};

export default PrivateRoute;
